// extracted by mini-css-extract-plugin
module.exports = {"pt-legend":"pt-legend-78076333f3786c0a5e2a03a804da848b","ball":"ball-60061ebfa72137dee2415bf7c4c84456","status-div-item":"status-div-item-3c250ce9965818e9005dd9ba2c5fc165"};